export default class {
    _inn;
    _name;
    _address;
    _phone;
    _bankAccountNumber;
    _bankName;
    _bankMfo;
    _oked;
    _okonx;
    _ndsRegistrationCode;


    get inn() {
        return this._inn
    }

    set inn(value) {
        this._inn = value
    }

    get name() {
        return this._name
    }

    set name(value) {
        this._name = value
    }

    get address() {
        return this._address
    }

    set address(value) {
        this._address = value
    }

    get phone() {
        return this._phone
    }

    set phone(value) {
        this._phone = value
    }

    get bankAccountNumber() {
        return this._bankAccountNumber
    }

    set bankAccountNumber(value) {
        this._bankAccountNumber = value
    }

    get bankName() {
        return this._bankName
    }

    set bankName(value) {
        this._bankName = value
    }

    get bankMfo() {
        return this._bankMfo
    }

    set bankMfo(value) {
        this._bankMfo = value
    }

    get oked() {
        return this._oked
    }

    set oked(value) {
        this._oked = value
    }

    get okonx() {
        return this._okonx
    }

    set okonx(value) {
        this._okonx = value
    }

    get ndsRegistrationCode() {
        return this._ndsRegistrationCode
    }

    set ndsRegistrationCode(value) {
        this._ndsRegistrationCode = value
    }

}